import { Component, Inject, Input } from '@angular/core';
import Env from '@ridango/core/env';
import { ApplicationFacade } from '@ridango/components';

enum IconType {
    GREY_INFO = 'grey-info',
    INFO = 'info',
    LIGHT_INFO = 'light-info'
}

@Component({
    selector: 'ridango-ui-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
    @Input() type: IconType;
    public assetsPath$ = this.applicationFacade.assetsPath$;

    @Input() iconColor: string;

    get showIcon() {
        return this.type === IconType.GREY_INFO || this.type === IconType.INFO || this.type === IconType.LIGHT_INFO;
    }

    constructor(
        @Inject('ENV') public env: Env,
        private applicationFacade: ApplicationFacade
    ) {}
}
